import type { FaireProductEntity } from "../../entity_types/product";

export const p_fhn7dp8kvx: FaireProductEntity = {
  token: "p_fhn7dp8kvx",
  type: "product",
  name: "Matte White Ceramic Bud Vase",
  brandName: "47th & Main (Creative Brands)",
  imageUrl:
    "https://cdn.faire.com/fastly/f1fd896315b189d6d3098369505534ad6b00f67a01004724a4aa045df65c30f5.jpeg",
  priceDollars: 4.73,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/55cc65ab2560bbe2cb5c165a684646b176c119fdc51361ce71a500f01a8ac8a9.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
